/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { IntegrationIDs, StaticIntegration } from 'cio/utils/integrations/static-integrations';
import AccountService from 'cio/services/account';

const icons = {
  add: 'add',
  externalLink: 'exit',
  seeDetails: 'chevron-right',
};
interface IntegrationsFeaturedBlockArgs {
  integration: StaticIntegration;
  isSuggestion?: boolean;
  index?: number;
  onClick?: () => unknown;
  totalBlocks: number;
}

export default class IntegrationsFeaturedBlock extends Component<IntegrationsFeaturedBlockArgs> {
  @service account!: AccountService;

  get cssClasses() {
    return [
      'featured-integrations__block',
      this.args.isSuggestion ? 'featured-integrations__block--suggestion' : null,
      this.args.integration?.enabled ? 'featured-integrations__block--enabled' : null,
    ]
      .compact()
      .join(' ');
  }

  get areWarehouseSyncsBlocked() {
    return !this.account.planFeatures.warehouseSync.enabled;
  }

  get integrationBlockIcon() {
    let { isSuggestion, integration } = this.args;

    if (isSuggestion) {
      return icons.add;
    }
    let isPipelines = integration.id === IntegrationIDs.cdpOut || integration.id === IntegrationIDs.cdpIn;
    return isPipelines ? icons.externalLink : icons.seeDetails;
  }
}
